<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <table ref="grid" class="mdl-data-table table table-responsive dataTable no-footer dtr-inline" width="100%">
                    <thead>
                    <tr>
                        <th>Actions</th>
                        <th>Fee</th>
                        <th>Type</th>
                        <th>Payment type</th>
                        <th style="min-width: 140px!important;">Value</th>
                        <th>Payee</th>
                        <th>Created by</th>
                    </tr>
                    </thead>
                    <tbody v-if="fees.length>0">
                    <tr v-for="fee in fees">
                        <td>
                            <ac-button class="btn btn-sm" :action="()=>{selectFee(fee)}">SELECT</ac-button>
                        </td>
                        <td>{{fee.name}}</td>
                        <td>{{fee.feeType}}</td>
                        <td>{{fee.strategyType}}</td>
                        <td style="min-width: 140px!important;">
                            <fee-formula :fee="fee">

                            </fee-formula>
                        </td>
                        <td>{{fee.payee}}</td>
                        <td>{{fee.creator}}</td>
                    </tr>
                    </tbody>
                    <tbody class="text-center" v-else>
                    <tr>
                        <td colspan="6">No records found</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import {FeeSelectionClass} from "./FeeSelectionClass.js";
    import FeeFormula from "./FeeFormula.vue";

    export default {
        name: "FeeSelection",
        components: {FeeFormula},
        props: {feeSelectionInstance: {type: [FeeSelectionClass], required: true}},
        data() {
            return {
                fees: [],
                grid: null
            }
        },
        methods: {
            async init() {
                this.fees = await this.feeSelectionInstance.getExistingFees();
                if (this.grid == null && this.fees.length > 0) {
                    //console.log(" $(this.$refs.grid) before DataTable call:", $(this.$refs.grid));
                    await this.$nextTick();//Wait until for loop has completed rendering all rows
                    this.grid = $(this.$refs.grid).DataTable({
                        responsive: true,
                        scrollX: true,
                        displayLength: 10
                    });
                    this.grid.columns.adjust().draw();
                }
            },
            selectFee(fee) {
                this.$emit('onFeeSelected', fee);
            }
        }
    }
</script>

<style scoped>

</style>